import { ForgotMfaForm } from '@/features/identity/components/ForgotMfaForm';

export function ForgotMfaPage() {
  return <ForgotMfaForm />;
}
